import URL from '@/http/rh/offre-emploi';
export default {
  namespaced: true,
  state: {
    currentOffre: null,
    postes: [],
    naturePostes: [],
    contratTypes: [],
  },

  getters: {
    currentOffre: (state) => state.currentOffre,
    postes: (state) => state.postes,
    naturePostes: (state) => state.naturePostes,
    contratTypes: (state) => state.contratTypes,
  },

  mutations: {
    SET_CURRENT_OFFRE(state, payload) {
      state.currentOffre = payload;
    },

    SET_POSTES(state, payload) {
      state.postes = payload;
    },

    SET_NATURE_POSTES(state, payload) {
      state.naturePostes = payload;
    },

    SET_CONTRAT_TYPES(state, payload) {
      state.contratTypes = payload;
    },
  },

  actions: {
    setPostes({ commit }, payload) {
      commit('SET_POSTES', payload);
    },
    setNaturePostes({ commit }, payload) {
      commit('SET_NATURE_POSTES', payload);
    },
    setContratTypes({ commit }, payload) {
      commit('SET_CONTRAT_TYPES', payload);
    },
    setCurrentOffre({ commit }, payload) {
      commit('SET_CURRENT_OFFRE', payload);
    },
    getOffre({ commit }, payload) {
      commit('SET_CURRENT_OFFRE', null);

      if (payload.edit) {
        return window.axios
          .get(URL.OFFRE_EMPLOI + '/' + payload.id, { params: { edit: true } })
          .then((resp) => {
            commit('SET_CURRENT_OFFRE', resp.data.offre_emploi);
          })
          .catch(() => {
            commit('SET_CURRENT_OFFRE', null);
          });
      } else {
        return window.axios
          .get(URL.OFFRE_EMPLOI + '/' + payload.id)
          .then((resp) => {
            commit('SET_CURRENT_OFFRE', resp.data.offre_emploi);
          })
          .catch(() => {
            commit('SET_CURRENT_OFFRE', null);
          });
      }
    },
  },
};
